<button
  class="ui-switch-row"
  role="switch"
  type="button"
  [class.ui-switch-row-checked]="checked()"
  [disabled]="disabled()"
  [attr.aria-label]="accessibleLabel()"
  [attr.aria-checked]="checked() ? 'true' : 'false'"
  (click)="handleToggle($event)"
>
  <span class="ui-switch-row-leading">
    <ng-content select="[uiSwitchRowLeading]" />
  </span>
  <span class="ui-switch-row-copy">
    <span class="ui-switch-row-title">{{ title() }}</span>
    @if (hasDescription()) {
      <span class="ui-switch-row-description">{{ description() }}</span>
    }
  </span>
  <span class="ui-switch-row-control" aria-hidden="true">
    <span class="ui-switch-row-thumb"></span>
  </span>
</button>
